module.exports = __webpack_public_path__ + "static/Coolmath1-c21fac1fe27cf9f29e5105af9166decc.png";